module.exports = __webpack_public_path__ + "img/gera5.jpg";